
import * as classNames from 'classnames';
import * as React from 'react';
import withStyles, { StyledComponentProps } from 'react-jss'
import { BrowserRouter as Router } from "react-router-dom";
import Api from './_context/Api';
import AppScroller from './_context/AppScroller';

import 'minireset.css';

import { polyfill } from 'smoothscroll-polyfill';
import Background from './components/Background';
import Menu from './components/Menu';
import Parts from './components/Parts';
import Fonts from './constants/fonts';
import fonts from './constants/fonts';
import stylesheet from './constants/stylesheet';

// smoothscroll-polyfill

polyfill();
export type AppProps = {};

const styles = {
  '@global': {
    'html, body': { ...stylesheet.Body },
    'body': {
      '-webkit-font-smoothing': 'antialiased',
      '-moz-osx-font-smoothing': 'grayscale',
    },
    'a': {
      textDecoration: 'none',
      color: 'inherit',
      cursor: 'pointer'
    },
    '.custom-style-subtitle-1': {
      display: 'block',
      textAlign: 'center',
      marginBottom: '1rem',
      ...stylesheet.Subtitle_1
    },
    '.custom-style-subtitle-2': {
      display: 'block',
      textAlign: 'center',
      ...stylesheet.Subtitle_2
    },
    '.custom-style-introduction': {
      ...stylesheet.Introduction
    },
    '.custom-style-quote': {
      ...stylesheet.Quote
    },
    '.custom-style-button': {
      display: 'block',
      border: '1px solid black',
      ...stylesheet.Caption,
      transition: 'all 0.3s ease-in-out',
      padding: 15,
      cursor: 'pointer',
      '&:hover': {
        color: '#FFF',
        background: '#000',
      }
    },
    '.custom-style-dropcaps': {
      float: 'left',
      fontSize: '2.5rem',
      margin: '0 0.05rem 0 -0.2rem',
      fontFamily: 'SackersGothicStd-light',
      lineHeight: '0.8',
    },
    '.custom-style-icon': {
      display: 'inline-block',
      margin: '0 10px 0 0',
      position: 'relative',
      ...fonts.Icons,
      fontSize: '1rem',
      textDecoration: 'none',
      '&:hover': {
        color: 'rgb(190, 190, 190)',
      },
      '& a': {
        textDecoration: 'none',
        border: 'none',
      },
      '& a:hover': {
        '&:after': {
          display: 'none'
        } 
      }
    },
    'strong': {
      ...fonts.Granjon.Bold,
    },
    'em': {
      ...fonts.Granjon.Italic,
    }
  },
  container: {
    ...Fonts.Granjon.Normal
  },
  menu: {
    bottom: 0,
    position: 'fixed',
    top: 0,
    pointerEvents: 'none',
    right: 0,
    left: 0,
    zIndex: 999
  },

  loaded: {
    // '& $header': {
    //   transform: 'translate3d(0, 0, 0)'
    // },
    // '& $legendOuter': {
    //   opacity: 1
    // },
    // '& $backgroundMask': {
    //   opacity: 0
    // }
  }
};

type Props = AppProps & StyledComponentProps<keyof typeof styles>;

type State = {
  loaded?: boolean;
  ready?: boolean;
  menuOpened?: boolean;
  refresh?: number;
};
class App extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this._toggleMenu = this._toggleMenu.bind(this);
    this._openMenu = this._openMenu.bind(this);
    this._onLoad = this._onLoad.bind(this);
    this.state = {};
  }
  public render() {
    const { classes } = this.props;
    const { loaded, menuOpened, refresh } = this.state;
    return (
      <Router>
        <Api>
          <AppScroller {...{ refresh }}>
            <div className={classNames(classes!.container, loaded && classes!.loaded)}>
              <Menu
                className={classNames(classes!.menu)}
                opened={!!menuOpened}
                loading={!loaded}
                toggle={this._toggleMenu}
              />
              <Background
                loading={!loaded}
                loaded={this._onLoad}
              />
              <Parts
                loaded={!!loaded}
                openMenu={this._openMenu}
              />
            </div>
          </AppScroller>
        </Api>
      </Router >
    );
  }
  private _onLoad() {

    this.setState(() => ({
      loaded: true,
      refresh: new Date().getTime()
    }));

  }
  private _openMenu() {
    this._toggleMenu(true);
  }
  private _toggleMenu(force?: boolean) {
    this.setState(({ menuOpened }) => ({
      menuOpened: force !== undefined && force || !menuOpened
    }))
  }
}

export default withStyles(styles)(App);



// WEBPACK FOOTER //
// ./src/App.tsx